<template>
    <span v-if="isSpinner" class="spinner">
        <font-awesome-icon :icon="icon" :size="size"/>
    </span>
    <font-awesome-icon v-else :icon="icon"/>
</template>

<script>
import Vue from 'vue';
import { mapIncludes } from '../utils';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faPlay,
    faPause,
    faSpinner,
    faHandPointer,
    faSearchPlus,
    faSlidersH,
    faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
    faPlay,
    faPause,
    faSpinner,
    faHandPointer,
    faSearchPlus,
    faSlidersH,
    faTimes,
);

export const ICONS = new Map([
    ['play', 'play'],
    ['pause', 'pause'],
    ['spinner', 'spinner'],
    ['pointer', 'hand-pointer'],
    ['zoom', 'search-plus'],
    ['configure', 'sliders-h'],
    ['close', 'times'],
]);

export const SIZES = new Map([
    ['small', 'xs'],
    ['medium', 'sm'],
    ['large', 'lg'],
]);

export default {
    props: {
        icon: {
            type: String,
            required: true,
            validator: (value) => {
                return mapIncludes(value, ICONS);
            },
        },
        size: {
            type: String,
            validator: (value) => mapIncludes(value, SIZES),
        },
    },
    computed: {
        isSpinner() {
            return this.icon === ICONS.get('spinner');
        },
    },
    components: { FontAwesomeIcon },
};
</script>

<style scoped>
    .spinner {
        animation: rotate 1.5s infinite linear;
    }
    @keyframes rotate {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(1turn);
        }
    }
</style>
